var api_url ="http://192.168.1.223:3068/api/"
var socket_url ='http://localhost:3068'
// api_url ="https://devapi.360inventory.app/api/"
var server = true;
if (["st01.thuytienfood.vn","st02.thuytienfood.vn"].includes(window.location.host)) {
    server = true;
}

if(server){
    api_url ="https://api.thuytienfood.vn/api/"
    socket_url ='https://api.thuytienfood.vn'
}




export {api_url,socket_url};